import { IThreePsCodeItem } from "./threePsCodes.model";

export enum ThreePsCodeTblKeys {
    CODE = "code",
    DESCRIPTION = "description",
    IS_REVIEW_COMPLETED = "isReviewCompleted",
    THREE_PS_DATA_UID = "threePsDataUid",
    USER_DEFINED_DESCRIPTION = "userDefinedDescription",
    USER_DEFINED_EMAIL_DESCRIPTION = "userDefinedEmailDescription",
    INCLUDE_IN_REPORTING = "includeInReporting",
    INCLUDE_IN_EMAIL = "includeInEmail",
    UPDATED_ON = "lastUpdatedOn",
    UPDATED_BY = "lastUpdatedBy",
    CATEGORY_FROM_FLA = "categoryFromFla",
}

export const { 
    CODE,
    DESCRIPTION,
    IS_REVIEW_COMPLETED,
    THREE_PS_DATA_UID,
    USER_DEFINED_DESCRIPTION,
    USER_DEFINED_EMAIL_DESCRIPTION,
    INCLUDE_IN_REPORTING,
    INCLUDE_IN_EMAIL,
    UPDATED_ON,
    UPDATED_BY,
    CATEGORY_FROM_FLA
} = ThreePsCodeTblKeys;

export const EMPTY_CODES: IThreePsCodeItem[] = [
    {
        [CODE]: "",
        [DESCRIPTION]: "",
        [IS_REVIEW_COMPLETED]: false,
        [THREE_PS_DATA_UID]: "",
        [USER_DEFINED_DESCRIPTION]: null,
        [USER_DEFINED_EMAIL_DESCRIPTION]: null,
        [INCLUDE_IN_REPORTING]: false,
        [INCLUDE_IN_EMAIL]: false,
        [UPDATED_ON]: null,
        [UPDATED_BY]: null,
        [CATEGORY_FROM_FLA]: "",
    },
];

export const UNSAVED_CHANGES_CONFIRMATION_MESSAGE =
    'You have unsaved changes. Are you sure you want to continue?';

export const DEFAULT_PAGE_INDEX = 1;
export const DEFAULT_PAGE_SIZE = 20;